module.exports = __webpack_public_path__ + "img/ck.87b36328.svg";